import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import {defaultVariabls} from "../../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Grid from "@material-ui/core/Grid/Grid";
import {connect} from "trim-redux";
import Typography from "@material-ui/core/Typography/Typography";
import {currencySymbol, price} from "../../../../../config/values";
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import SingleOrderItem from "../../../orders/components/SingleOrderItem";
import { updateRedux} from "../../../../../config/Security";
import GetConfirmationText from "../../../../components/elements/GetConfirmationText";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import axios from "axios";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';

import Button from "@material-ui/core/Button/Button";
import SubTitleLight from "../../../../components/elements/SubTitleLight";
import ShippingConfirmationButton from "../../../orders/shop_orders/ShippingConfirmationButton";
import Alert from "@material-ui/lab/Alert/Alert";
import moment from "jalali-moment";
import ReceiptRoundedIcon from '@material-ui/icons/ReceiptRounded';
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import ShowOrderHistoryButton from "./ShowOrderHistoryButton";
import EditShippingCodeBtn from "../../../orders/shop_orders/EditShippingCodeBtn";
class SingleOrder extends React.Component {

    state = {
        order:this.props.item,
        action_clicked:false,
        auto_pay:this.props.item.auto_pay,
    };
    classes = this.props.classes;
    async handleConfirmOrder(status){
        let {order} = this.state;
        let data = new FormData();
        data.append('id', order.id);
        data.append('status', status);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/change_order_status`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataEdited, {
                    variant: 'success',
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });
    }
    async handlePayOrder(){
        let {action_clicked} = this.state;
        if(!action_clicked){
            this.setState({
                action_clicked:true
            });
            let {order} = this.state;
            let data = new FormData();
            data.append('id', order.id);

            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/factor/pay_order_to_shop`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.purchaseDone, {
                        variant: 'success',
                    });
                    updateRedux();
                    this.props.reload();

                })
                .catch(error => {
                    if(error.response.data === "admin_wallet_is_low"){
                        this.props.enqueueSnackbar(Translate.admin_wallet_is_low, {
                            variant: 'error',
                        });
                    }else {
                        this.props.enqueueSnackbar(Translate.purchaseRejected, {
                            variant: 'error',
                        });
                    }

                    this.setState({
                        loading:false,
                        SubmitLoading: false,
                    });
                });
        }



    }
    async handleChangeAutoPay(){
        await this.setState({
            loading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let data = new FormData();
        let {order} = this.state;
        data.append('id', order.id);
        await axios.post(`${defaultVariabls.url}/order/toggle_auto_pay`, data,config)
            .then(response => {
                this.props.reload();
            }).catch(error => {
                console.log(error.response)
                this.setState({
                    loading:false
                })
            })
    }
    render(){
        let {shop} = this.state.order;
        let {order,auto_pay} = this.state;
        let {factor} = this.props;

        return (
            <Grid container spacing={2} alignItems="center">
                {
                    !!shop &&
                    <Grid item xs={12}>
                        <div className="order-items-holder mb-15 mt-15">
                            <Typography>{Translate.shopName} <span className="result">{shop.name}</span></Typography>
                            <Typography>
                                <FiberManualRecordRoundedIcon fontSize="small"/>
                            </Typography>
                            <Typography>{Translate.phone} <span className="result">{shop.phone}</span></Typography>
                            {
                                !!order.sell_agent_id &&
                                    <>
                                        <Typography>
                                            <FiberManualRecordRoundedIcon fontSize="small"/>
                                        </Typography>
                                        <Typography>{Translate.sell_agent} <span className="result"><a className="link" href={`${defaultVariabls.React}/manage/agent/${order.sell_agent.id}`} target="_blank">{order.sell_agent.user.first_name + " " + order.sell_agent.user.last_name}</a></span></Typography>
                                        <Typography>{Translate.sell_commission_amount} <span className="result">{price(order.sell_commission)} {currencySymbol}</span></Typography>
                                    </>
                            }
                            {
                                !!order.buy_agent_id &&
                                <>
                                    <Typography>
                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                    </Typography>
                                    <Typography>{Translate.buy_agent} <span className="result"><a className="link" href={`${defaultVariabls.React}/manage/agent/${order.buy_agent.id}`} target="_blank">{order.buy_agent.user.first_name + " " + order.buy_agent.user.last_name}</a></span></Typography>
                                    <Typography>{Translate.buy_commission_amount} <span className="result">{price(order.buy_commission)} {currencySymbol}</span></Typography>
                                </>
                            }
                            <Typography style={{display:"flex",alignItems:"center"}}>

                                {
                                    (this.props.factor.status !== "rejected" && this.props.factor.status !== "not_payed" && this.props.factor.status !== "need_verification") ?
                                        <>
                                            {
                                                order.status === "pending" ?
                                                    <>
                                                        <GetConfirmationText
                                                            tooltip={Translate.changeStatus}
                                                            className={this.classes.link}
                                                            style={{
                                                                cursor:"pointer",
                                                                color: this.props.primary_color,
                                                                marginBottom:0,
                                                                border: "1px solid #3887bf",
                                                                padding: "5px 8px",
                                                                borderRadius: 6
                                                            }}
                                                            handleAction={() => this.handleConfirmOrder('ok')}
                                                            question={Translate.isOrderReceivedToYou}
                                                            icon={<CheckBoxIcon/>}
                                                            color={this.props.primary_color}
                                                        >
                                                            {Translate.receivingConfirmationShop}
                                                        </GetConfirmationText>
                                                        <GetConfirmationText
                                                            tooltip={Translate.changeStatus}
                                                            className={this.classes.link}
                                                            style={{
                                                                cursor:"pointer",
                                                                color: "#ed1d1d",
                                                                marginBottom:0,
                                                                border: "1px solid #ed1d1d",
                                                                padding: "5px 8px",
                                                                borderRadius: 6,
                                                                marginRight:5
                                                            }}
                                                            handleAction={() => this.handleConfirmOrder('reject')}
                                                            question={Translate.rejectOrderShopQ}
                                                            icon={<CheckBoxIcon/>}
                                                            color={this.props.primary_color}
                                                        >
                                                            {Translate.rejectOrderShop}
                                                        </GetConfirmationText>
                                                    </>
                                                    :
                                                    order.status === "ready" ?
                                                        <ShippingConfirmationButton
                                                            transfer_type={factor.transfer_type}
                                                            order_id={order.id}
                                                            reload={
                                                                () => this.props.reload()
                                                            }
                                                        />
                                                        : null
                                            }
                                        </> : null
                                }
                                {
                                    this.props.factor.status !== "rejected" ?
                                        <>
                                            {
                                                (order.status === "done" || order.status === "received") &&
                                                <GetConfirmationText
                                                    tooltip={Translate.payToShop}
                                                    className={this.classes.link}
                                                    style={{
                                                        cursor:"pointer",
                                                        color: this.props.primary_color,
                                                        marginBottom:0,
                                                        border: "1px solid #33d51d",
                                                        padding: "5px 8px",
                                                        borderRadius: 4
                                                    }}
                                                    handleAction={() => this.handlePayOrder()}
                                                    question={Translate.payToShopAreYouSure}
                                                    icon={<CheckBoxIcon/>}
                                                    color={this.props.primary_color}
                                                >
                                                    {Translate.payToShop}
                                                </GetConfirmationText>
                                            }
                                        </> : null
                                }
                                {
                                    (factor.status !== "not_payed" && factor.status !== "need_verification" && factor.status !== "rejected") &&
                                    <Button
                                        color="primary"
                                        component={"a"}
                                        href={`${defaultVariabls.website}/view/receipt/${factor.number}/${order.id}`}
                                        target="_blank"
                                        variant="outlined"
                                        style={{margin:"0 5px"}}
                                        startIcon={<ReceiptRoundedIcon/>}
                                    >
                                        {Translate.viewReceipt}
                                    </Button>
                                }
                            </Typography>
                        </div>
                    </Grid>
                }
                {
                    (order.status === "done") &&
                    <Grid item xs={12}>
                        <Alert
                            severity="info"
                            action={
                                <FormControlLabel
                                    style={{marginRight:10,color: !auto_pay ? "#ed1d1d" : ""}}
                                    control={
                                        <Switch
                                            checked={auto_pay}
                                            onChange={this.handleChangeAutoPay.bind(this)}
                                            value={auto_pay}
                                            color="primary"
                                        />
                                    }
                                    label={auto_pay ? Translate.auto_pay_on : Translate.auto_pay_off}
                                />
                            }
                        >
                            {
                                !!auto_pay ?
                                    <span>
                                    {Translate.pay_to_shop_text1} <strong>{`${moment(order.checkout_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}</strong> {Translate.pay_to_shop_text_admin}
                                    </span> :
                                    <span>
                                        {Translate.auto_pay_off_text}
                                    </span>
                            }
                        </Alert>
                    </Grid>
                }
                {
                    (order.status === "received") &&
                    <Grid item xs={12}>
                        <Alert severity="info">
                            {Translate.pay_to_shop_received_text1} <strong>{`${moment(order.checkout_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}</strong> {Translate.pay_to_shop_received_text2}
                        </Alert>
                    </Grid>
                }
                <Grid item xs={12}>
                    <div className="order-items-holder">
                        <Typography>
                            {Translate.status} <span className={"order_badge "+order.status} >{Translate[order.status]}</span> <ShowOrderHistoryButton histories={order.histories}/>
                        </Typography>
                        {
                            !!order.shipping_code &&
                            <>
                                <Typography>
                                    <FiberManualRecordRoundedIcon fontSize="small"/>
                                </Typography>
                                <Typography>{Translate.shipping_code} <span className="result">{order.shipping_code}</span>
                                    {
                                        factor.transfer_type === "post" &&
                                            <EditShippingCodeBtn
                                                order_id={order.id}
                                                shipping_code={order.shipping_code}
                                                reload={
                                                    () => this.props.reload()
                                                }
                                            />
                                    }

                                </Typography>
                            </>
                        }
                        {
                            !!order.shipment_at &&
                            <>
                                <Typography>
                                    <FiberManualRecordRoundedIcon fontSize="small"/>
                                </Typography>
                                <Typography>{Translate.shipment_at} <span className="result">{`${moment(order.shipment_at).locale('fa').format( 'YYYY/M/D H:mm')}`}</span></Typography>
                            </>
                        }
                        <Typography>
                            <FiberManualRecordRoundedIcon fontSize="small"/>
                        </Typography>
                        <Typography>{Translate.commission} <span className="result">{price(order.commission)} {currencySymbol}</span></Typography>
                        <Typography>
                            <FiberManualRecordRoundedIcon fontSize="small"/>
                        </Typography>
                        <Typography>{Translate.transfer_price} <span className="result">
                            {
                                order.total_transfer_price > 0 ?
                                    <>
                                        {price(order.total_transfer_price)} {currencySymbol}
                                    </> :
                                    Translate.free
                            }

                        </span></Typography>
                        <Typography>
                            <FiberManualRecordRoundedIcon fontSize="small"/>
                        </Typography>
                        {
                            (!!order.discount && !!order.total_discount_code_price) &&
                                <>
                                    <Typography>{Translate.discount_code} <span className="result"> {price(order.total_discount_code_price)} {currencySymbol} - {order.discount}</span></Typography>
                                    <Typography>
                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                    </Typography>
                                </>
                        }
                        <Typography>{Translate.total_price_to_get} <span className="result">{price(order.provider_checkout_price)} {currencySymbol}</span></Typography>

                    </div>

                </Grid>
                <Grid item xs={12}>
                    <SubTitleLight align="left">{Translate.productsList}</SubTitleLight>
                </Grid>
                <Grid item xs={12}>
                    {
                        order.order_items.map((item,index) => (
                            <SingleOrderItem factor_status={factor.status}  key={index} item={item} no_shop reload={() => this.props.reload()}/>
                        ))
                    }
                </Grid>
            </Grid>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color,
    secondary_color: state.secondary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SingleOrder))));